// src/Layout.js
import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

// Components
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Footer from "./components/Footer";

function Layout() {
  const [authorized, setAuthorized] = useState(true); // Örnek: giriş yapmış kullanıcı
  const navigate = useNavigate();

  useEffect(() => {
    if (!authorized) {
      navigate("/girisyap");
    }
  }, [authorized, navigate]);

  return (
    <div className="admin-layout">
    <Sidebar />
       <div className='content-container'>
          <Header />
 <div className='outlet-container'>
            <Outlet />
              <Footer />
          </div>
        
        </div>
    </div>
  );
}

export default Layout;
